import React from 'react';
import {styled} from '@mui/system';
import {Button, Menu, MenuItem} from '@mui/material';

interface IconButtonMenuProps {
  icon: JSX.Element;
  disabled?: boolean;
  color: 'primary' | 'secondary';
  variant?: 'contained' | 'outlined';
  items: { title: string; onClick: () => void }[];
}

const IconButtonMenu = styled(Button)(() => ({
  minWidth: '60 px',
  overflow: 'hidden',
  height: '50px',
  whiteSpace: 'nowrap',
  paddingLeft: '10px',
  paddingRight: '10px',
  display: 'flex !important',
  justifyContent: 'center !important',
  alignItems: 'center !important',
}));

const IconButtonMenuComponent = (props: IconButtonMenuProps) => {
  const {icon, disabled = false, variant = 'contained', color = 'primary', items} = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButtonMenu
        disabled={disabled}
        variant={variant}
        color={color}
        onClick={handleClick}
      >
        {icon}
      </IconButtonMenu>
      <Menu open={open} onClose={handleClose} onClick={handleClose} anchorEl={anchorEl}>
        {items.map((item) => (
          <MenuItem onClick={item.onClick}>
            {item.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default IconButtonMenuComponent;
